import { gql } from '@apollo/client'

export const CREATE_TERMINAL_MUTATION = gql`
  mutation CreateTerminal($input: CreateTerminalInput!) {
    createTerminal(input: $input) {
      terminal {
        id
      }
    }
  }
`

export const PATCH_TERMINAL_MUTATION = gql`
  mutation PatchTerminal($id: ID!, $input: PatchTerminalInput!) {
    patchTerminal(id: $id, input: $input) {
      terminal {
        id
      }
    }
  }
`

export const DELETE_TERMINAL_MUTATION = gql`
  mutation DeleteTerminal($id: ID!) {
    deleteTerminal(id: $id) {
      found
      deletedId
    }
  }
`
